import Dialog from './Dialog';
export * from './Dialog';
export default Dialog;